import { Component, OnInit, OnDestroy,Injectable } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ShareService} from './../services/services';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/publishReplay';
let headers = new Headers();
headers.append('Access-Control-Allow-Origin', '*');
headers.append('Content-Type', 'application/x-www-form-urlencoded');
let options = new RequestOptions({ headers: headers });	 

export class Blog {

    constructor(public slug: string, public image: string,public blog_title: string,public blog_description:string) { }
}

@Injectable()
export class BlogService {

  
   
    public _productlist;
    public _productlatest;
    public _products:Array<any>;
    constructor(
      private http: Http,
      
      private shareService: ShareService) {
      this._productlist = null;
  
    }
    getlatestproduct(limit:string){
    
    
		let apirul=this.shareService.getApiUrl()+'/latestblog';
    
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });	 
	    if(limit)
	    {
		    apirul=apirul+'/'+limit;	
	    }
	    
  	
	   	if (!this._productlatest) { 	     
        this._productlatest = this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);
               
            
            }
            
         return this._productlatest;
    }
	getProductlist(slug:string) {
	    //console.log(slug);
	    
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/bloglist/'+slug;
	   //	if (!this._productlist) { 	     
        this._productlist = this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);
               
            
           // }
            
         return this._productlist;
	}
	
	getProduct(slug:string) {
	   
	   let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/blog/'+slug;
	   	//if (!this._products.slug) { 	     
        let output= this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);
               
            
          //  }
            
         return output;
	    
	    
	}
	doContactUs(params) {
	    //console.log(slug)
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');
	    ///alert(this.getToken());
	     
	   let options= new RequestOptions({ headers:headers });
	   
	   	let apirul=this.shareService.getApiUrl()+'/productinquery';
	   	
	   	
         let formData = JSON.stringify(params);
         let body = 'request='+formData;	
             
	   	 
        let output= this.http.post(apirul,body,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);  
       
        return output;
	         
      
	}
		
	handleError(error) {
        console.error("Got the error: " + JSON.stringify(error));
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/blog/blog.service.ts